import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/material.module';
import { SidePanelService } from '@lib/services';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [],
    imports: [CommonModule, AngularMaterialModule, MatIconModule],
    exports: [AngularMaterialModule],
    providers: [SidePanelService],
})
export class SharedPeerToPeerSuccessModule {}
